module.exports = __webpack_public_path__ + "static/media/menunewicon.ec6a5e8b.svg";